export default __webpack_public_path__ + "static/media/Apples.fe520369.webp";